export default __webpack_public_path__ + "static/media/Paints-Primers.e069f360.jpg";